/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
};

const ExpandHyphenIcon: FC<IProps> = ({ width = 16, height = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none">
    <path d="M3.33398 8.37207H12.6673" stroke="#262626" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
  </svg>
);

export default ExpandHyphenIcon;
